import {BaseModel} from "../../../../infrastructure/models/base-model";
import {observable, computed} from "mobx";
import {LanguageViewModel} from "../../../../domain/locale/models/language/language.view-model";

export class LanguageMenuModuleMenuModel extends BaseModel {
  type: String;
  isMenuOpen: Boolean;
  screenWidth: Number;
  @observable selectedLanguage: LanguageViewModel;
  @observable languages: Array<LanguageViewModel>;


  constructor(type: String, selectedLanguage: LanguageViewModel, languages: Array<LanguageViewModel>, isMenuOpen, screenWidth) {
    super();

    this.type = type;
    this.selectedLanguage = selectedLanguage;
    this.languages = languages;
    this.isMenuOpen = isMenuOpen;
    this.screenWidth = screenWidth;
  }

  @computed get logoSize(): Number {
    return console.error(this.constructor.name + 'Implementation is missing: logoSize');
  }

  @computed get className(): String {
    return console.error(this.constructor.name + 'Implementation is missing: className');
  }

  @computed get headerName(): String {
    return console.error(this.constructor.name + 'Implementation is missing: headerName');
  }

  @computed get shouldRenderButtonLabel(): Boolean {
    return console.error(this.constructor.name + 'Implementation is missing: shouldRenderButtonLabel');
  }

  @computed get headerItems(): Array<LanguageViewModel> {
    return console.error(this.constructor.name + 'Implementation is missing: headerItems');
  }

  @computed get collapsedItems(): Array<LanguageViewModel> {
    return console.error(this.constructor.name + 'Implementation is missing: collapsedItems');
  }

  @computed get shouldArrowOpenMenu(): Boolean {
    return console.error(this.constructor.name + 'Implementation is missing: shouldArrowOpenMenu');
  }

  @computed get showSelectedLanguageLabel(): Boolean {
    return console.error(this.constructor.name + 'Implementation is missing: showSelectedLanguageLabel');
  }

  @computed get shouldRenderHeaderFullDisplay(): Boolean {
    return console.error(this.constructor.name + 'Implementation is missing: shouldRenderHeaderFullDisplay');
  }

  @computed get shouldCollapsedOnBgClick(): Boolean {
    return console.error(this.constructor.name + 'Implementation is missing: shouldCollapsedOnBgClick');
  }

  @computed get items(): Array<LanguageViewModel> {
    return console.error(this.constructor.name + 'Implementation is missing: items');
  }

  @computed get numOfHeaderItemsDisplay(): Number {
    return console.error(this.constructor.name + 'Implementation is missing: numOfHeaderItemsDisplay');
  }
}
